<template>
  <label v-if="label" class="form-label cursor-pointer" :for="id">{{ label }}:</label>
  <label class="relative inline-block mt-3">
    <input :id="id" type="checkbox" ref="input" v-model="model" :value="value"
      :true-value="1" :false-value="0" :class="{ error: error }" class="peer invisible" />
    <span
      class="absolute top-0 left-0 w-9 h-5 cursor-pointer rounded-full bg-gray-200 border border-slate-300 transition-all duration-100 peer-checked:bg-primary-100"></span>
    <span
      class="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full z-10 transition-all duration-100 peer-checked:translate-x-4"></span>
  </label>

</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    modelValue: { type: [Array, Number] },
    value: { type: [Boolean, Object] },
    label: { type: String }
  },
  emits: ['update:modelValue'],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    }
  }
}
</script>